import type { EmailSuppression, Page } from '@servicetim/shared';
import { useMutation } from '@tanstack/react-query';
import { adminPath, useApiContext } from './client';
import { DEFAULT_PAGE_SIZE, pageQuery, usePagedList } from './paging';

const base = adminPath('/email-suppressions');

/** `GET /admin/v1/email-suppressions` (tenant admin). Addresses the ses-events worker
 *  (Bolt 10) suppressed after a hard bounce or complaint. */
export function useEmailSuppressions(options: { pageSize?: number } = {}) {
  const { request, keys } = useApiContext();
  const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE;
  return usePagedList<EmailSuppression>({
    queryKey: keys.emailSuppressions.list({ pageSize }),
    fetchPage: (cursor, signal) =>
      request<Page<EmailSuppression>>('GET', base, { query: pageQuery(cursor, pageSize), signal }),
  });
}

/** `DELETE /admin/v1/email-suppressions/{id}`: clears one address so sending resumes. */
export function useClearEmailSuppression() {
  const { request, keys, invalidate } = useApiContext();
  return useMutation({
    mutationFn: (id: string) => request<unknown>('DELETE', `${base}/${id}`),
    onSuccess: () => invalidate(keys.emailSuppressions.all),
  });
}
